import { view } from "@risingstack/react-easy-state";
import type { CategoryContext } from "../../common/types/categoryTypes";
import categoryStore from "../../stores/categories/categoryStore";
import featuresStore from "../../stores/features/featuresStore";
import { CategoryNavigation } from "./CategoryNavigation";
import Level2CategoryNavigation from "./Level2CategoryNavigation";

type PageNavigationProps = {
   catInfo: CategoryContext;
};

const PageNavigation = ({ catInfo }: PageNavigationProps) => {
   const { navigationTestVariant } = featuresStore;
   const rootCategory = categoryStore.categories[0];
   const level1CategoryId = catInfo.levels[1]?.id || "";
   const level2CategoryId = catInfo.levels[2]?.id || "";
   const currentCategoryId = level2CategoryId || level1CategoryId;

   const sideMenuNarrowStyle = "md:tw-hidden";
   const sideMenuWideStyle = "tw-hidden md:tw-block";

   if (navigationTestVariant === "megamenu" || !rootCategory) {
      return null;
   }

   const currentLevel1Category = rootCategory.children?.find(
      (category) =>
         category.id === currentCategoryId || category.children?.find((level2Category) => level2Category.id === currentCategoryId)
   );
   const currentLevel2Category = currentLevel1Category?.children?.find((category) => category.id === currentCategoryId);

   if (navigationTestVariant === "sidemenu") {
      return (
         <>
            <div className={sideMenuNarrowStyle}>
               <CategoryNavigation
                  rootCategory={rootCategory}
                  currentLevel1Category={currentLevel1Category}
                  currentLevel2Category={currentLevel2Category}
               />
            </div>
            <div className={sideMenuWideStyle}>
               {!!currentLevel1Category && (
                  <Level2CategoryNavigation
                     currentLevel1Category={currentLevel1Category}
                     currentLevel2Category={currentLevel2Category}
                  />
               )}
            </div>
         </>
      );
   }

   if (navigationTestVariant === "topmenu") {
      return (
         <CategoryNavigation
            rootCategory={rootCategory}
            currentLevel1Category={currentLevel1Category}
            currentLevel2Category={currentLevel2Category}
         />
      );
   }

   return null;
};

export default view(PageNavigation);
